export default "__VITE_ASSET__7db1892c__"